import React from 'react';
import ArticleList from '../ArticleList/ArticleList';
import ActionsAdList from '../ActionsAdList/ActionsAdList';

const News = props => {
    return (
        <div className="profile-user-content">
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <ArticleList />
                    </div>
                    <div className="col-md-4">
                        <ActionsAdList />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default News;
